<template lang='pug'>
  v-list.elevation-2.mb-4.pt-0.rounded( two-line )
    v-subheader {{ subheader }}
    v-list-tile( ripple )
      v-list-tile-avatar( color='primary white--text' ) {{ value[itemAvatarText] | first }}
      v-list-tile-content
        v-list-tile-title {{ value[itemTitle] }}
        v-list-tile-sub-title {{ value[itemSubTitle] }}
</template>

<script>
  export default {
    filters: {
      first(val = '') {
        return val ? String(val).slice(0, 1) : ''
      }
    },
    methods: {
      submit() {

      }
    },
    props: {
      color: {
        type: String,
        default: 'primary',
      },
      itemAvatarText: String,
      itemTitle: String,
      itemSubTitle: String,
      subheader: String,
      value: {
        type: Object,
        default: () => ({}),
      }
    },
  }
</script>

<style>
  .rounded {
    border-radius: 2px;
    overflow: hidden;
  }
</style>
